














import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class SubMenu extends Vue {
   @Prop() subItems? : any;

   @Prop() projectName?: string;

   navigate(path: string) {
     this.$router.push(`/${this.projectName}/${path}`);
   }
}
